import { MsalProvider } from '@azure/msal-react';
import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { setUseWhatChange } from '@simbathesailor/use-what-changed';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import { msalInstance } from '../msalInstance';
import GenericError from './GenericError';
import { ResettablePage } from './Pages/Resettable.page';

export function PageRoot() {
  setUseWhatChange(process.env.NODE_ENV === 'development');
  const appInsights = useAppInsightsContext();

  const onError = (error: Error, info: { componentStack?: string | null }) => {
    console.error(error);
    appInsights.trackException({ exception: error, properties: { info, url: window.location.href } });
  };

  return (
    <MsalProvider instance={msalInstance}>
      <ResettablePage>
        <ScrollRestoration />
        <ErrorBoundary fallback={<GenericError />} onError={onError}>
          <Outlet />
        </ErrorBoundary>
      </ResettablePage>
    </MsalProvider>
  );
}
